import React from "react";

// Parses **bold** markers and returns React nodes
export default function RichText({ text = "", className = "" }) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <span className={className}>
      {parts.map((part, i) => {
        const m = part.match(/^\*\*([^*]+)\*\*$/);
        if (m) return <strong key={i} className="font-semibold text-white">{m[1]}</strong>;
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
